






























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class MatterView extends Vue {
  public items: Common.Task[] = new Array(0);
  public params: Common.TaskQuery = new Common.TaskQuery();
  public importQuery = new Common.ImportQuery('タスク', 'Task');
  public exportQuery = new Common.ExportQuery('タスク', this.params);
  @Prop() public taskId:string;    
  public sortOptions: any = [
    { value: 'id', text: 'タスク(ID)' },
    { value: 'matter', text: '案件' },
    { value: 'type', text: '種別' },
    { value: 'state', text: '状態' },
    { value: 'limitdate', text: '期限日' },
  ];

  public badgeStyles: any = ['olive', 'orange', 'blue', 'maroon', 'navy', 'teal', 'purple', 'gray'];
  public badgeStyles2: any = ['olive', 'orange', 'blue', 'maroon', 'gray'];
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }
  public queryProvider(search:string, perPage:number,currentPage:number){
    var temp = new Common.MatterMasterQuery();
    temp.search = search;
    temp.perPage = perPage;
    temp.currentPage = currentPage;
    return temp;
  }
  private created() 
  {
    if (this.taskId) this.params.id = Number.parseInt(this.taskId) ;
  }
  public async onCreate(obj: Common.Task) {
    // 案件番号がある場合はセットする
    if (this.params.matter != 0) {
      const query = new Common.MatterQuery();
      query.id = this.params.matter;
      await this.$api.execute(query).then((data: Common.LoadResult) => {
        if (data.records > 0) obj.parent = data.result[0];
      });
    }

    const workflows = this.$api.formatter.getOptions('workflow_task');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;

    return Promise.resolve(obj);
  }
  public onExec() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.Task;
    this.$router.push('/project/matter?favorite=mid' + obj.parent.id);
  }
  public get workflowRequired() {
    return this.$api.formatter.getOptions('workflow_task').length != 0;
  }
}
